import React, { useState, useEffect, memo } from "react";
import ChatContainer from "../chatContainer";
import { db } from "../../firebase";
import styles from "./Dashboard.module.scss";
import CountUp from "react-countup";
import { getCountFromServer, collection as fsCollection } from "firebase/firestore";

// Memoize CountUp component to prevent unnecessary re-renders
const MemoizedCountUp = memo(CountUp);

export default function StatsWidgets() {
  const [counts, setCounts] = useState({
    livePlayerCount: 0,
    liveNoteCount: 0,
    scoutingOverviewCount: 0,
    bgOverviewCount: 0,
  });
  const [isMobile, setIsMobile] = useState(false);

  // Efficiently fetch counts using Firestore's aggregation
  const getDocsCount = async (collection_name) => {
    const snapshot = await getCountFromServer(fsCollection(db, collection_name));
    return snapshot.data().count;
  };

  const getCounts = async () => {
    const playerCountPromise = getDocsCount("player-profile");
    const noteCountPromise = getDocsCount("reports");
    const scoutingOverviewCountPromise = getDocsCount("scouting-overview");
    const bgOverviewCountPromise = getDocsCount("background-overview");

    // Wait for all promises to resolve in parallel
    const [playerCount, noteCount, scoutingOverviewCount, bgOverviewCount] = await Promise.all([
      playerCountPromise,
      noteCountPromise,
      scoutingOverviewCountPromise,
      bgOverviewCountPromise,
    ]);

    setCounts({
      livePlayerCount: playerCount,
      liveNoteCount: noteCount,
      scoutingOverviewCount: scoutingOverviewCount,
      bgOverviewCount: bgOverviewCount,
    });
  };

  useEffect(() => {
    getCounts();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={styles.content}>
      <div>
        <div>
          <p>Total Players</p>
          <span>
            <MemoizedCountUp start={0} end={counts.livePlayerCount} duration={2.5} />
          </span>
        </div>

        <div>
          <p>Total Reports</p>
          <span>
            <MemoizedCountUp start={0} end={counts.liveNoteCount} duration={2.5} />
          </span>
        </div>

        <div>
          <p>Background Overviews</p>
          <span>
            <MemoizedCountUp start={0} end={counts.bgOverviewCount} duration={2.5} />
          </span>
        </div>

        <div>
          <p>Scouting Overviews</p>
          <span>
            <MemoizedCountUp start={0} end={counts.scoutingOverviewCount} duration={2.5} />
          </span>
        </div>
      </div>
      {!isMobile && (
        <div className={styles.messageBoard}>
          <ChatContainer />
        </div>
      )}
    </div>
  );
}
